import React from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../homepage/Header';
import Footer from '../homepage/Footer';
import PlanSelector from '../../components/PlanSelector';
import './pricing.css';

function Pricing() {
  const history = useHistory();

  const handlePlanSelect = (plan) => {
    // Redirect to organization signup with selected plan info
    // The plan data will be available in the location state
    history.push('/organization-signup', { selectedPlan: plan });
  };

  return (
    <div className="position-relative">
      <Header />
      <div className="pricing-page-container" style={{ width: '75%', margin: '0 auto' }}>
        <div className="pricing-page">
          <PlanSelector
            context="pricing"
            onPlanSelect={handlePlanSelect}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Pricing;
